import type { ElementRef, QueryList } from '@angular/core';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScrollService {
  scrollToElementByIndex(list: QueryList<ElementRef>, index: number, offset = 0): void {
    // Since only one detail section is visible at a time due to *ngIf,
    // the QueryList will only contain that one element
    const EL = list?.first?.nativeElement;

    if (!EL) {
      console.warn('No element found in QueryList');
      return;
    }

    const TOP = EL.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: TOP, behavior: 'smooth' });
  }
}
